export const ROUTE_PATHS = {
    addPanel: 'add-panel',
    editPanel: 'edit-Panel',
    home: 'home',
    dashboard: 'dashboard',
    browse: 'browse',
    settings: 'settings',
    newFolder: 'folder/new',
    login: 'login',
    downtimeDashbord: 'downtime-dashbord',
    userEvent: 'user-event',
    import: 'import',
    trends: 'trends',
    groups: 'groups',
    user: 'user',
    groupId: 'groupId',
    editGroupId: 'editGroupId',
    editUser: 'editUser',
    changePassword: 'ChangePassword',
    executor: 'executor',
    executorLogs: 'executorLogs',
    executorLogsByID: 'executorLogsByID',
    apcmDashboard: 'dashboard',
    assetsLiveData: 'assetsLiveData',
    priceRequest: 'priceRequest',
    execLogs: 'execLogs',
    priceRequestExec: 'priceRequestExec',
    tableData: 'tableData',
    groupsByID: 'GroupsByID',
    noConfirmed: 'pendingRequest',
    noExecuted: 'pendingExecuted',
};

const FULL_SCREEN_ROUTES = [
    ROUTE_PATHS.addPanel,
    ROUTE_PATHS.browse,
    ROUTE_PATHS.newFolder,
    ROUTE_PATHS.downtimeDashbord,
    ROUTE_PATHS.editPanel,
];

const SHOW_DRAWER_ROUTES = [
    // ROUTE_PATHS.browse,
    // ROUTE_PATHS.newFolder,
    // ROUTE_PATHS.downtimeDashbord,
    ROUTE_PATHS.userEvent,
    // ROUTE_PATHS.import,
    ROUTE_PATHS.groups,
    ROUTE_PATHS.user,
    ROUTE_PATHS.groupId,
    ROUTE_PATHS.editGroupId,
    ROUTE_PATHS.editUser,
    ROUTE_PATHS.changePassword,
    ROUTE_PATHS.executor,
    ROUTE_PATHS.executorLogs,
    ROUTE_PATHS.executorLogsByID,
    ROUTE_PATHS.apcmDashboard,
    ROUTE_PATHS.assetsLiveData,
];

export const VIEWER_ROUTES = [
    ROUTE_PATHS.groups,
    ROUTE_PATHS.user,
];

export const EXECUTOR_ROUTES = [
    ROUTE_PATHS.groups,
    ROUTE_PATHS.user,
    ROUTE_PATHS.priceRequest
];

export const isFullScreenRoute = path => FULL_SCREEN_ROUTES.includes(path.split('/')[1]);

export const isShowDrawerRoute = path => SHOW_DRAWER_ROUTES.includes(path.replace('/', ''));

export const isViewerRoute = (pathname) => {
    const path = pathname?.split('/')[1];
    let viewerRoute = VIEWER_ROUTES.includes(path);
    if (path === ROUTE_PATHS.apcmDashboard || path === ROUTE_PATHS.userEvent) {
        viewerRoute = false;
    }
    return viewerRoute;
};

// export const isRestrictedRoute = (pathname) => {
//     const path = pathname?.split('/')[1];
//     let viewerRoute = EXECUTOR_ROUTES.includes(path);
//     if (path === ROUTE_PATHS.priceRequestExec || path === ROUTE_PATHS.executor || path === ROUTE_PATHS.apcmDashboard || path === ROUTE_PATHS.userEvent) {
//         viewerRoute = false;
//     }
//     return viewerRoute;
// };
